module.exports = __webpack_public_path__ + "static/img/traseira.994e10e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traseira.png
// module id = tRFi
// module chunks = 3